"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AboutViewModel = void 0;
const BaseViewModel_1 = require("../../core/render/BaseViewModel");
class AboutViewModel extends BaseViewModel_1.BaseViewModel {
}
exports.AboutViewModel = AboutViewModel;
//# sourceMappingURL=AboutViewModel.js.map